import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { http } from '@/apis/aipass'
import { SurveyResultParams, SurveyResultResponse } from './survey-types'
import { env } from '@/libs/env'

export const fetchSurveyResult = createAsyncThunk<SurveyResultResponse, SurveyResultParams, { rejectValue }>(
  'survey/fetchSurveyResult',
  async (params, { rejectWithValue }) => {
    try {
      const response = await http({
        method: 'get',
        url: `${env('BASE_API_V3')}/guest/surveys/result`,
        params: {
          hotelId: params.hotelId,
          reservationId: params.reservationId,
        },
      })
      return response.data
    } catch (error) {
      return rejectWithValue(error)
    }
  },
)

interface SurveyResultState {
  result: SurveyResultResponse | null
  loading: boolean
}

const initialState: SurveyResultState = {
  result: null,
  loading: false,
}

const surveyResultSlice = createSlice({
  name: 'surveyResult',
  initialState,
  reducers: {
    resetSurveyResult: state => {
      state.result = null
      state.loading = false
    },
  },
  extraReducers: builder => {
    builder.addCase(fetchSurveyResult.fulfilled, (state, action) => {
      state.result = action.payload
      state.loading = false
    })
    builder.addCase(fetchSurveyResult.rejected, state => {
      state.loading = false
    })
    builder.addCase(fetchSurveyResult.pending, state => {
      state.loading = true
    })
  },
})

export const { resetSurveyResult } = surveyResultSlice.actions
export const surveyResultReducer = surveyResultSlice.reducer
